
import { Component, Prop, Vue, } from 'vue-property-decorator';
import HeaderText from '~/components/header-text/header-text.vue';

@Component({
	components: {
		HeaderText,
	},
})
export default class TermsConditionPage extends Vue {

	@Prop({
		type: String,
		required: true,
	})
	contactUsLocation!: string;

	@Prop({
		type: String,
		required: true,
	})
	privacyLink!: string;
}
